<p-panel header="{{ panelList.title }}">
  <div style="min-height: 26rem" class="panelContent">
    <div class="grid mb-0">
      <p-checkbox
        class="selectAllCkbox"
        *ngIf="panelList.enableSelection"
        name="panelCardSelection"
        [(ngModel)]="parentSelection"
        [binary]="true" 
        (onChange)="selectDeselectAll($event)"
        [disabled]="isSelectAllDisabled"
      ></p-checkbox>       
      <div *ngIf="panelList.enableFilter" class="grid menu">
        <div class="col">
          <span class="p-input-icon-left">
            <i class="pi pi-filter"></i>
            <input
              type="text"
              [(ngModel)]="filterKey"
              pInputText
              placeholder="Filter by keyword"
              (input)="applyFilter(null, null)"
            />
          </span>
        </div>
        <div class="col" *ngFor="let filter of filterItems; index as i">
          <p-multiSelect
            [options]="filter.options"
            placeholder="{{ filter.name }}"
            optionLabel="name"
            optionValue="value"
            [displaySelectedLabel]="true"
            [maxSelectedLabels]="1"
            [selectedItemsLabel]="'{0} items selected'"
            class="filter"
            (onChange)="applyFilter(filter.column, i)"
            [(ngModel)]="selectedFilterItems[i]"
            [resetFilterOnHide]="true"
          >
            <ng-template pTemplate="footer">
              <p-button
              appPreventDoubleClick
                type="button"
                label="Clear"
                styleClass="p-button-text"
                icon="pi pi-times"
                (debounceClick)="clearFilter(filter.column,i)"
              ></p-button>
            </ng-template>
          </p-multiSelect>
        </div>
        <div class="col">
          <div *ngIf="isMoreFilters">
            <button
              pButton
              appPreventDoubleClick
              type="button"
              id="panel_moreFilters_hidden"
              class="mr-3 p-button-outlined p-button-text p-button-info"
              pTooltip="More Filters"
              icon="fa fa-angle-double-down"
              *ngIf="moreFilters"
              (debounceClick)="populateMoreFilters()"
            ></button>
            <button
            appPreventDoubleClick
              pButton
              type="button"
              class="mr-3 p-button-outlined p-button-text p-button-info"
              pTooltip="Show less filters"
              id="panel_moreFilters_shown"
              *ngIf="hideFilters"
              (debounceClick)="hideShownFilters()"
              icon="fa fa-angle-double-up"
            ></button>
          </div>
          <div class="ml-1">
            <p-button
            appPreventDoubleClick
              type="button"
              styleClass="p-button-text p-button-rounded"
              icon="pi pi-filter-slash"
              (debounceClick)="clearAllFilters()"
            ></p-button>
          </div>
        </div>
        <div
          class="grid mb-0 ml-2 min-w-full"
          *ngIf="populateAfterClickOnMoreFilter"
        >
          <div
            class="col-2 ml-3"
            *ngFor="let filter of additionalFilters; index as i"
          >
            <p-multiSelect
              [options]="filter.options"
              placeholder="{{ filter.name }}"
              optionLabel="name"
              optionValue="value"
              [displaySelectedLabel]="true"
              [maxSelectedLabels]="2"
              [selectedItemsLabel]="'{0} items selected'"
              class="filter"
              (onChange)="applyFilter(filter.column, i+filterItemsCount)"
              [(ngModel)]="selectedFilterItems[i+filterItemsCount]"
              [resetFilterOnHide]="true"
            >
              <ng-template pTemplate="footer">
                <p-button
                appPreventDoubleClick
                  type="button"
                  label="Clear"
                  styleClass="p-button-text"
                  icon="pi pi-times"
                  (debounceClick)="clearFilter(filter.column,i+filterItemsCount)"
                ></p-button>
              </ng-template>
            </p-multiSelect>
          </div>
        </div>
      </div>
      <div class="col justify-content-center align-items-center additional-items-content" *ngIf="ifAdditionalItems">
        <ng-content select=".additional-items"></ng-content>
      </div>   
      <div class="col align-items-center sortBy">
      <p-menubar
      *ngIf="panelList.enableSort"
      [model]="sortItems"
      class="menubar-item menu-class"
      expandMode="inline"
    >
    </p-menubar>
      </div>   
      <div class="col align-items-center panelToggler" *ngIf="panelList.enableToggling || panelList.enableExport">
        <bpt-menu-button 
        [model]="items" 
        [label]="label" 
        [icon]="icon"
        [compact]="compact"
        [stroked]="stroked"
        [disabled]="disabled">
    </bpt-menu-button>
      </div>

    </div>
    <div class="panel-list-content" *ngIf = "!noResultFound && !showLoader">
      <div *ngFor="let item of panelList.lists; index as i" class="grid">
        <div *ngIf="panelList.enableSelection" class="col select-cards">
          <p-checkbox
            name="panelCardSelection"
            [value]="item"
            [ngModel]="getSelecteditems(item,i)"
            [binary]="true"
            [disabled]="checkForDisable(item)"
            (onChange)="selectItemsChange(item, $event, i)"
            pTooltip="{{ getToolTipForDisabledCheckBox(item) }}"
          ></p-checkbox>
        </div>
        <div
          [ngClass]="{
            'panel-card-selection': panelList.enableSelection,
            'panel-card-no-selection': !panelList.enableSelection
          }"
        >
          <app-panel-card
            [ngClass]="{'highlight-panel' : i == activeIndex}"
            [data]="item"
            [isCardToggleable]="isCardToggleable"
            (click)="onPanelCardClick(item,i)"
          >
            <ng-template #template1 let-data="data">
              <ng-container
                [ngTemplateOutlet]="templateRef.first"
                [ngTemplateOutletContext]="{ dataVar: item }"
              >
              </ng-container>
            </ng-template>
            <ng-template #template let-data="data">
              <ng-container
                [ngTemplateOutlet]="templateRef.last"
                [ngTemplateOutletContext]="{ dataVar: item }"
              >
              </ng-container>
            </ng-template>
          </app-panel-card>
        </div>
      </div>
    </div>
    <div class="panel-list-content" style="padding: 100px 0;" *ngIf = "noResultFound && !showLoader">
      <app-empty-results></app-empty-results>
    </div>
  </div>
</p-panel>
